import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import CustomLink from '../CustomLink/CustomLink';
import FiftyFifty from '../FiftyFifty/FiftyFifty';
import NumberedListProps from './NumberedList.interface';
import Image from '../Image/Image';
import Heading, { HeadingTypes } from '../Heading/Heading';
import { Theme } from '../../interfaces/enums/Theme.enum';
import RichText from '../RichText/RichText';

const NumberedList: React.FC<NumberedListProps> = ({
  list_items,
  partners,
  is_default,
}) => {
  return (
    <section className="pb-16 my-16 border-b border-text/body">
      <ul>
        {list_items?.length &&
          list_items.map(({ heading, body, _uid }, idx) => (
            <li
              className={`flex space-x-6 relative ${
                idx < list_items.length - 1 ? 'pb-14' : ''
              }`}
              key={_uid}
            >
              <div className="h-[56px] min-w-[56px] inline-flex justify-center items-center rounded-full bg-text/body-accent relative z-[3]">
                <p className="text-system/white font-bold">{idx + 1}</p>
              </div>
              {idx < list_items.length - 1 && (
                <span className="w-[1px] bg-border/light h-[calc(100%)] absolute top-[0] right-0 left-1 mx-auto z-[2]"></span>
              )}
              <div>
                {heading && (
                  <Heading
                    text={heading}
                    headingType={HeadingTypes.h4}
                    className="pb-[16px] transition-all text-text/body"
                  />
                )}
                {body && <RichText content={body} />}
              </div>
            </li>
          ))}
      </ul>
    </section>
  );
};

export default memo(NumberedList);
